import axios from 'axios';
import { BASE_API_URL, LOCAL_STORAGE } from '../constants';

function checkStatus(responseData) {
  if(responseData.status >= 200 && responseData.status < 300)
    return { data: responseData.data, headers: responseData.headers, status: responseData.status };

  const error = new Error((responseData.data.response && responseData.data.response.message) || '');

  error.response = responseData.data;
  throw error;
}

export function processRequest(url = '', method = 'GET', data = {}, json = true) {
  let headers = {
    'Content-Type': 'application/json',
    'Authorization': localStorage.getItem(LOCAL_STORAGE.AUTH_TOKEN) || ''
  };
  const body = json ? JSON.stringify(data) : data;

  return axios({
    method,
    data: body,
    headers,
    url: BASE_API_URL + url,
    credentials: 'same-origin'
  })
  .then(res => checkStatus(res));
}
